import { FabricObject, StaticCanvas, Textbox } from 'fabric';
import {
  applyAllAttachTo,
  applyAllChainRecenter,
  applyAllFitToContent,
  applyAllTextStyleRules,
  buildPieceIdIndex,
  resizeAllPills,
  walkObjects,
  wrapToText,
  type WrapTextConfig
} from '@doer/frontend-components/creativity-editor';
import { readObjectConfig } from './object-config';

const getWrapTextConfig = (obj: FabricObject): WrapTextConfig | undefined =>
  readObjectConfig<WrapTextConfig>(obj, 'wrapText', c => typeof c.pieceId === 'string');

function applyAllWrapText(canvas: StaticCanvas, index: Map<string, FabricObject>): void {
  walkObjects(canvas, obj => {
    const cfg = getWrapTextConfig(obj);
    if (!cfg) return;
    const source = index.get(cfg.pieceId);
    if (!(source instanceof Textbox)) return;
    wrapToText(obj, source, cfg);
  });
}

/**
 * Runs after every effect. Order matters: each step relies on the previous one's sizing.
 *   1. fitToContent      — textboxes with explicit config grow/shrink to their text.
 *   2. wrapText          — textboxes mirroring another textbox use that final width.
 *   3. textStyleRules    — substring-driven char styling. Must run before sizing because bold/font-family changes char widths.
 *   4. resizeAllPills    — pills wrap their text + padding.
 *   5. attachTo          — fits chain participants implicitly, then positions the chain.
 *   6. chainRecenter     — tighten parent Group's bbox and re-center children after the chain settled.
 */
export function consolidate(canvas: StaticCanvas, pieceIdIndex?: Map<string, FabricObject>): void {
  const index = pieceIdIndex ?? buildPieceIdIndex(canvas);
  applyAllFitToContent(canvas);
  applyAllWrapText(canvas, index);
  applyAllTextStyleRules(canvas);
  resizeAllPills(canvas);
  applyAllAttachTo(canvas);
  applyAllChainRecenter(canvas);
  canvas.requestRenderAll();
}
